<template>
    <div class="title-group">
        <div class="title">{{title}}</div>
        <div  alt="" class="line"></div>
        <div class="desc">{{desc}}</div>
    </div>
</template>

<script>
    export default {
        data() {
            return {}
        },
        props:['title','desc']
    }
</script>

<style lang="scss" scoped>
    .title-group{
        .title{
            margin-top: 80px;
            display: inline-block;
            line-height: 50px;
            color: $title-color;
            font-size: 40px;
            font-weight: 500;
            padding-bottom: 12px;
        }
        .line{
            width: 200px;
            height: 4px;
            background-image: url("../assets/icon/line.png");
            background-size: contain;
            background-repeat: no-repeat;
            display: block;
            margin-bottom: 60px;
        }
        .desc{
            color: $text-color;
            font-size: $font-size-large;
            line-height: 22px;
        }
    }
</style>